  import React, { useEffect, useRef, useState } from "react";
  import { Link, useNavigate } from "react-router-dom";
  import Table from "../../../../core/common/dataTable/index";
  import { exam } from "../../../../core/data/json/exam";
  import dayjs from "dayjs";
  import { all_routes } from "../../../router/all_routes";
  import { useUserPermissions } from "../../../UserPermissionsContext";
  import Cookies from "js-cookie";
  import { Button, Checkbox, CheckboxChangeEvent, Select, Spin } from "antd";

  type Permission = { id: number; name: string };
  type Admin = {
    id: number;
    branch_name: string;
    is_wizklub: boolean;
    is_offline: boolean;
    branch: number;
  };

  type Agent = {
    id: number;
    username: string;
  };

  const { Option } = Select;


  const WizklubAgentsAttendance = () => {
    const routes = all_routes;
    const navigate = useNavigate();
    const data = exam;
    const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
    const day = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${month}-${day}-${year}`;
    const defaultValue = dayjs(formattedDate);
    const jwtToken = Cookies.get("authToken");
    const { userPermissions, webApi } = useUserPermissions();
    const [isLoading, setIsLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [permissions, setPermissions] = useState<Permission[]>([]);
    const [admin, setAdmin] = useState<Admin[]>([]);
    const [from, setFrom] = useState();
    const [to, setTo] = useState<number>();
    const [totalCount, setTotalCount] = useState();
    const [toastMessage, setToastMessage] = useState("");
    const [showSuccessToast, setShowSuccessToast] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [searchText, setSearchText] = useState<string>("");
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [AsignshowCard, setAsignShowCard] = useState(false);
    const [selectedAgent, setSelectedAgent] = useState<string[]>([]);
    const [agentsLoading, setAgentsLoading] = useState(false);
    const [agentsDropdown, setAgentsDropdown] = useState<Agent[]>([]);
    const [dangerToastMessage, setDangerToastMessage] = useState("");
    const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
    const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);

    const checkPermission = (action: any, subject: any) => {
      return userPermissions.some(
        (ability) => ability.action === action && ability.subject === subject
      );
    };

    useEffect(() => {
      if (!checkPermission("change_agentsdailyattendance", "agentsdailyattendance")) {
        navigate(routes.crmLandingPage);
      } else {
        fetchData(currentPage, pageSize, searchText);
        fetchAgentsData();
      }
    }, [userPermissions]);

    const handleApplyClick = () => {
      if (dropdownMenuRef.current) {
        dropdownMenuRef.current.classList.remove("show");
      }
    };

    const fetchAgentsData = async () => {
      setAgentsLoading(true);
      try {
        const response = await fetch(
          `${webApi}/teammgmt/team_leader_dropdown/`,
          options
        );
        const data = await response.json();
        setAgentsDropdown(data);
      } catch (error) {
        console.error("Failed to fetch agents", error);
      } finally {
        setAgentsLoading(false);
      }
    };

    const getModalContainer = () => {
      const modalElement = document.getElementById("modal-datepicker");
      return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
    };

    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    };

    const fetchGroupsData = async (
      page: number,
      pageSize: number,
      searchText: string
    ) => {
      const response = await fetch(
        `${webApi}/user/agent_attendance/?page=${page}&page_size=${pageSize}&search=${searchText}`,
        options
      );
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.code === "token_not_valid") {
          navigate("/login");
        }
        throw new Error(errorData.detail || "Failed to fetch user data");
      }
      return await response.json();
    };

    const fetchData = async (
      page: number,
      pageSize: number,
      searchText: string
    ) => {
      setIsLoading(true); // Start loading
      try {
        const [groupsData] = await Promise.all([
          fetchGroupsData(page, pageSize, searchText),
        ]);
        setTotalPages(groupsData.total_pages);
        setAdmin(groupsData.results);
        setTotalCount(groupsData.total_count);
        setFrom(groupsData.from);
        setTo(groupsData.to);
        setTotalCount(groupsData.total_count);
        setToastMessage(groupsData.message || "submitted successfully!");
        setShowSuccessToast(true);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false); // Stop loading
      }
    };

    const handleTableChange = (pagination: any) => {
      const { current, pageSize } = pagination;
      setCurrentPage(current);
      setPageSize(pageSize);
      fetchData(current, pageSize, searchText); // Fetch new data based on the updated pagination
    };

    const handleSearch = (value: string) => {
      setSearchText(value);
      fetchData(currentPage, pageSize, value);
    };

    const updateBranchDetails = async (
      id: any,
      updateData: { [x: number]: any }
    ) => {
      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify(updateData),
      };
      const url = `${webApi}/user/agent_attendance/${id}/`;
      const response = await fetch(url, requestOptions);
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error("Network response was not ok");
      }
    };

    const handleCheckboxChange = async (
      id: any,
      field: string,
      value: boolean
    ) => {
      const updateData = { [field]: value };
      try {
        await updateBranchDetails(id, updateData);
        await fetchData(currentPage, pageSize, searchText);
      } catch (error) {
        console.error("Error updating branch details:", error);
      }
    };

    const handleSelect = (
      student_id: any,
      selectedRowKeys: string[],
      setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
    ) => {
      const selectedIds = [...selectedRowKeys];
      const index = selectedIds.indexOf(student_id);
      if (index >= 0) {
        selectedIds.splice(index, 1);
      } else {
        selectedIds.push(student_id);
      }
      setSelectedRowKeys(selectedIds);
    };

    const handleSelectAll = (
      e: CheckboxChangeEvent,
      data: { id: any }[],
      setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
    ) => {
      if (e.target.checked) {
        const allIds = data.map((item) => item.id);
        setSelectedRowKeys(allIds);
      } else {
        setSelectedRowKeys([]);
      }
    };

    const handleAgentAssignment = async (e: { preventDefault: () => void }) => {
      e.preventDefault();
      setAgentsLoading(true);
      try {
        const response = await fetch(
          `${webApi}/branches/assign_summer_camp_team_leaders_to_branches/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${jwtToken}`,
            },
            body: JSON.stringify({
              branch_ids: selectedRowKeys,
              leader_id: selectedAgent,
              // target_date_: targetDate,
            }),
          }
        );

        const data = await response.json();
        if (!response.ok) {
          setDangerToastMessage(data.message);
          setShowSolidDangerToast(true);
          throw new Error("Failed to assign agent");
        }

        console.log("Agent assigned successfully", data);
        setToastMessage(data.message);
        setshowSolidSuccessToast(true);
        setSelectedRowKeys([]);
        setSelectedAgent([]);
        // setTargetDate("");
        setAsignShowCard(false);
        fetchData(
          currentPage,
          pageSize,
          searchText,
        );
      } catch (error) {
        console.error("Failed to assign agent", error);
      } finally {
        setAgentsLoading(false);
      }
    };

    const handleSelectChange = (value: string[]) => {
      setSelectedAgent(value);
    };

    const columns = [
      // {
      //   title: "Action",
      //   dataIndex: "action",
      //   render: (_text: any, record: { id: any }) => (
      //     <Checkbox
      //       checked={selectedRowKeys.includes(record.id)}
      //       onChange={() =>
      //         handleSelect(record.id, selectedRowKeys, setSelectedRowKeys)
      //       }
      //     />
      //   ),
      //   key: "action",
      //   // align: "center",
      // },
      {
        title: "Agent",
        dataIndex: "agent_username",
      },
      {
        title: "Date",
        dataIndex: "date",
      },
      checkPermission("change_agentsdailyattendance", "agentsdailyattendance") ? {
        title: "Is Present",
        dataIndex: "is_present",
        render: (
          text: any,
          record: { id: any; is_present: boolean | undefined }
        ) => (
          <input
            type="checkbox"
            name={`wizklub_${record.id}`}
            checked={record.is_present}
            onChange={() =>
              handleCheckboxChange(record.id, "is_present", !record.is_present)
            }
          />
        ),
      }: {},
      // {
      //   title: "Is SummerCamp Lead",
      //   dataIndex: "is_summercamp_lead",
      //   render: (
      //     text: any,
      //     record: { id: any; is_summercamp_lead: boolean | undefined }
      //   ) => (
      //     <input
      //       type="checkbox"
      //       name={`wizklub_${record.id}`}
      //       checked={record.is_summercamp_lead}
      //       onChange={() =>
      //         handleCheckboxChange(record.id, "is_summercamp_lead", !record.is_summercamp_lead)
      //       }
      //     />
      //   ),
      // },

      // {
      //   title: "Is Offline",
      //   dataIndex: "is_offline",
      //   render: (text: any, record: { id: any; is_offline: boolean | undefined; }) => (
      //     <input
      //       type="checkbox"
      //       name={`offline_${record.id}`}
      //       checked={record.is_offline}
      //       onChange={() => handleCheckboxChange(record.id, 'is_offline', !record.is_offline)}
      //     />
      //   ),
      // },
    
    ];

    return (
      <div>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
              <div className="my-auto mb-2">
                <h3 className="page-title mb-1">Wizklub Agent Attandence</h3>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.wizklubDashboard}>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Attandance
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                {/* <div className="mb-2">
                  {checkPermission("add", "summercamppriority") && (
                    <Link to={routes.SummerCampAddPriorities} className="btn btn-primary">
                      <i className="ti ti-square-rounded-plus-filled me-2" />
                      Add Priority
                    </Link>
                  )}
                </div> */}
              </div>
            </div>
            {/* /Page Header */}
            {/* Guardians List */}
            <div
              className="card "
              style={{
                width: "100%",
                boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                borderRadius: "10px",
              }}
            >
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                <h4 className="mb-3">Agents List</h4>
                {/* <div className="d-flex align-items-center flex-wrap ms-auto">
                  <Checkbox
                    indeterminate={
                      selectedRowKeys.length > 0 &&
                      selectedRowKeys.length < admin.length
                    }
                    checked={selectedRowKeys.length === admin.length}
                    onChange={(e) =>
                      handleSelectAll(e, admin, setSelectedRowKeys)
                    }
                  >
                    Select All
                  </Checkbox>

                  {checkPermission("assign_agent_targets", "Records") && (
                    <button
                      className="btn btn-primary"
                      onClick={() => setAsignShowCard(true)}
                      disabled={selectedRowKeys.length === 0}
                      style={{ marginLeft: "10px", marginBottom: "5px" }}
                    >
                      Assign Agent
                    </button>
                  )}
                </div> */}
              </div>
              <div className="card-body p-0 py-3">
                <div
                  className="serch-global text-right"
                  style={{ marginRight: "15px" }}
                >
                  <input
                    type="search"
                    className="form-control form-control-sm mb-3 w-auto float-end"
                    value={searchText}
                    placeholder="Search"
                    onChange={(e) => handleSearch(e.target.value)}
                    aria-controls="DataTables_Table_0"
                  ></input>
                </div>
                {isLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      height: "100vh",
                      paddingTop: "20px",
                    }}
                  >
                    <Spin /> {/* Display loader while loading */}
                  </div>
                ) : (
                  <Table
                    columns={columns}
                    dataSource={admin}
                    Selection={false}
                    pagination={{
                      current: currentPage,
                      pageSize: pageSize,
                      locale: { items_per_page: "" },
                      nextIcon: <span>Next</span>,
                      prevIcon: <span>Prev</span>,
                      defaultPageSize: 10,
                      showSizeChanger: true,
                      total: totalCount,
                      showTotal: (total: any, range: any[]) =>
                        `${range[0]}-${range[1]} of ${total}`,
                      pageSizeOptions: ["10", "20", "100"],
                    }}
                    onChange={handleTableChange} // Move this outside of pagination
                    onSearch={handleSearch}
                  />
                )}
              </div>
            </div>
            {/* /Guardians List */}
          </div>
        </div>

        {AsignshowCard && (
          <>
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 1049,
              }}
            />
            <div
              className="card"
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "20%",
                boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
                borderRadius: "10px",
                zIndex: 1050,
                backgroundColor: "#f9f9f9",
                padding: "20px",
              }}
            >
              <form onSubmit={handleAgentAssignment}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          style={{
                            paddingBottom: "10px",
                            fontWeight: "bold",
                            color: "#555",
                          }}
                        >
                          Select Agent
                        </label>
                        {agentsLoading ? (
                          <Spin />
                        ) : (
                          <Select
                          // mode="multiple" 
                            value={selectedAgent}
                            onChange={handleSelectChange}
                            style={{
                              width: "100%",
                            }}
                            showSearch
                            filterOption={(input, option) => {
                              if (!option || !option.children) return false; // Check if option or option.children is undefined
                              const label = option.children as unknown as string; // Ensure that option.children is treated as a string
                              return label
                                .toLowerCase()
                                .includes(input.toLowerCase());
                            }}
                          >
                            {agentsDropdown.map((agent) => (
                              <Option key={agent.id} value={agent.id}>
                                {agent.username}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </div>
                      {/* <div className="mb-3">
                          <label
                            className="form-label"
                            style={{
                              paddingBottom: "10px",
                              fontWeight: "bold",
                              color: "#555",
                            }}
                          >
                            Target Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            value={targetDate}
                            onChange={(e) => setTargetDate(e.target.value)}
                            required
                          />
                        </div> */}
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Button
                    className="btn btn-light me-2"
                    onClick={() => setAsignShowCard(false)}
                  >
                    Cancel
                  </Button>
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={agentsLoading}
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </>
        )}
        <>
          {/* Delete Modal */}
          <div className="modal fade" id="delete-modal">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <form>
                  <div className="modal-body text-center">
                    <span className="delete-icon">
                      <i className="ti ti-trash-x" />
                    </span>
                    <h4>Confirm Deletion</h4>
                    <p>
                      You want to delete all the marked items, this cant be undone
                      once you delete.
                    </p>
                    <div className="d-flex justify-content-center">
                      <Link
                        to="#"
                        className="btn btn-light me-3"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </Link>
                      <Link
                        to="#"
                        data-bs-dismiss="modal"
                        className="btn btn-danger"
                      >
                        Yes, Delete
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* /Delete Modal */}
        </>
      </div>
    );
  };

  export default WizklubAgentsAttendance;
